import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getMarketData } from "@helium10/re-core";
import { memo, useMemo } from "react";
import styled, { css } from "styled-components";
import { useOverflown } from "../../../core/hooks/useOverflown";
import { CopyButton } from "../../button";
import { Tooltip } from "../../floating";
import { cssBody100, cssBody200, cssBody400 } from "../../typography/styles";
import { FlagLabel, flagsMarketplaceRelation } from "../../ultraSelect/marketplace/marketplace";
export const DefaultBeforeContent = ({ label }) => {
    return _jsx(Flex, { children: label });
};
export const DefaultAfterContent = ({ label }) => {
    return (_jsxs(Flex, { children: [_jsx(Icon, {}), label] }));
};
export const DataBlocks = memo(({ size = "100", blocks, marketplace, blocksInline = false, overflowBlocksTooltip = true, blockTooltipOptions, }) => {
    const { isOverflown, checkOverflown } = useOverflown();
    const _blocks = useMemo(() => {
        const mainBlocks = blocks || [];
        const totalBlocks = marketplace
            ? [
                {
                    text: (_jsx(FlagLabel, { children: flagsMarketplaceRelation[getMarketData("store", marketplace).domain] })),
                },
                ...mainBlocks,
            ]
            : mainBlocks;
        return totalBlocks.map((info, index) => {
            return (_jsxs(BlockWrapper, { "$size": size, children: [blocksInline && !isOverflown && index > 0 ? (_jsx(Tooltip, { placement: "top", colorType: "light", interactive: true, appendTo: document.body, content: totalBlocks.slice(1, totalBlocks.length + 1).map((info, index) => {
                            return (_jsxs(TooltipItem, { children: [info.text, info.copyContent && (_jsx(BlockCopyButton, { size: "50", beforeCopyContent: info.beforeCopyContent, afterCopyContent: info.afterCopyContent, copyContent: info.copyContent }))] }, index));
                        }), children: _jsx("div", { children: info.text }) })) : (info.text), info.copyContent && (_jsx(BlockCopyButton, { size: "50", beforeCopyContent: info.beforeCopyContent, afterCopyContent: info.afterCopyContent, copyContent: info.copyContent, tooltipOptions: blockTooltipOptions }))] }, index));
        });
    }, [blocks, blocksInline, isOverflown, marketplace, size]);
    return (_jsx(Blocks, { onMouseEnter: overflowBlocksTooltip ? checkOverflown : undefined, "$blocksInline": blocksInline, children: _blocks }));
});
const textTypography = {
    100: cssBody200,
    400: cssBody400,
    dropdown: cssBody100,
};
export const BlockCopyButton = styled(CopyButton) `
  margin-left: 4px;
`;
export const Blocks = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  ${({ $blocksInline }) => $blocksInline &&
    css `
      display: inline;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      div,
      ${BlockCopyButton} {
        display: inline !important;
        white-space: nowrap;
      }

      ${FlagLabel} {
        display: inline !important;
        vertical-align: text-top;
      }
    `}
`;
export const BlockWrapper = styled.div `
  ${({ $size }) => textTypography[$size]}
  position: relative;
  display: flex;
  align-items: center;
  position: relative;

  & + & {
    padding-left: 18px;

    &::after {
      content: "";
      width: 2px;
      height: 2px;
      left: 8px;
      border-radius: 2px;
      background: ${(p) => p.theme.systemColors.grey400};
      position: absolute;
      top: 50%;
    }
  }
`;
const TooltipItem = styled.div `
  display: flex;
  align-items: center;
  margin-left: 4px;
`;
const Icon = styled(FontAwesomeIcon).attrs({ icon: faCheck }) `
  margin-right: 8px;
  font-size: 16px;
  height: 16px;
  color: ${({ theme }) => theme.systemColors.green400};
`;
const Flex = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
`;
